import Vue from 'vue';
import modal from './Notify.vue'
import * as lib from "@/util/lib.js"
let notify = {}

notify.init = function(msg,opt={}){
	if(window.notify){
		window.notify.hide();//document.body.removeChild($('#alert')[0])
		window.notify=null;
	}
	let options = {...opt};
	let V = Vue.extend(modal);
	let vm = new V;
	let oDiv = document.createElement('div');
	vm.$mount(oDiv);
	vm.value = msg;
	notify.el = vm.$el;
	$("#app").append(vm.$el);
	// document.body.appendChild(vm.$el);
  window.notify=vm;
  // console.log(opt.title)
  if(opt.title)	vm.show(opt.title)
  else vm.show()

};

notify.install = function (Vue,options) {
    Vue.prototype.$notify = notify.init;
    
//  function (msg,opt={}) {
//      // if(notify.el) {
//		// 	lib.windowCtrl('#alert','true')
//		// }else{
//			$('#alert')[0] && document.body.removeChild($('#alert')[0])
//			options = {...options,...opt}
//			let V = Vue.extend(modal)
//			let vm = new V
//			let oDiv = document.createElement('div')
//			vm.$mount(oDiv)
//			vm.value = msg
//			notify.el = vm.$el
//			document.body.appendChild(vm.$el)
//			// lib.windowCtrl('#alert','true')
//			vm.show();
//		// }
//      // setTimeout(()=>{
//		// 	lib.windowCtrl('#alert','false')
//      //     document.body.removeChild(vm.$el)
//      //     notify.el = null
//      // },options.delay);
//  }
}


export default notify



// WEBPACK FOOTER //
// ./src/plugins/notify/index.js